import "phaser";
import { Game, Math } from "phaser";
import App from "../main";
import { GAMEZOP_STATE } from "./libs/GameZopSDK";

declare const gamezop: any;
export default class Preload extends Phaser.Scene {

    slingRacer: Phaser.Scene;

    bar: Phaser.GameObjects.Sprite;
    fill: Phaser.GameObjects.Sprite;
    logo: Phaser.GameObjects.Sprite;
    car: Phaser.GameObjects.Sprite;
    bg: Phaser.GameObjects.Sprite;

    gameZop_SDKLoading: Phaser.GameObjects.Sprite;
    gameZop_SDKLoaded: Phaser.GameObjects.Sprite;
    gameZop_LoadingBg: Phaser.GameObjects.TileSprite;
    gameZop_Loading: Phaser.GameObjects.Sprite;
    gameZop_Loaded: Phaser.GameObjects.Sprite;

    isSceneLoaded: boolean = false;

    private loadingScreen:Phaser.GameObjects.Container;

    // public loadScreen: Phaser.GameObjects.Container;
    constructor() {
        super('preload');
    }

    init() {

        const width = window.outerWidth;
        const height = window.outerHeight;

        this.gameZop_LoadingBg = this.add.tileSprite(0, 0, width, height, 'gameZopLoadingBg');
        this,this.gameZop_LoadingBg.setTileScale(1)
        this,this.gameZop_LoadingBg.setScale(2)
        
        this.gameZop_Loading = this.add.sprite(0, 0, 'gameZopLoading');
        this.gameZop_Loading.setScale(1.5);

        this.gameZop_Loaded = this.add.sprite(0, 0, 'gameZopLoaded');
        this.gameZop_Loaded.setCrop(0, 0, 350, 131);
        this.gameZop_Loaded.setScale(1.5);

        this.loadingScreen = this.add.container(this.cameras.main.width / 2, this.cameras.main.height / 2);

        this.loadingScreen.add([this.gameZop_LoadingBg, this.gameZop_Loading, this.gameZop_Loaded]);
        this.loadingScreen.sendToBack(this.bg);
        this.loadingScreen.scale = 0.5;
    }

    preload() {
        this.load.multiatlas('spritesAtlaas', 'Sprites/sprites.json', 'Sprites');
        this.load.atlas('smoke', 'flares.png', 'flares.json');
        this.load.image('Fire', 'Fire.png');

        this.load.audio('click', 'Audio/click.mp3');
        this.load.audio('latch', 'Audio/Latch.mp3');
        this.load.audio('crash', 'Audio/Crash.mp3');
        this.load.audio('drift', 'Audio/Drift.mp3');
        this.load.audio('gem', 'Audio/Gem.mp3');
        this.load.audio('bgm', 'Audio/BGM.mp3');

        this.load.spritesheet('carSpriteSheet', 'Sprites/carSpriteSheet.png', { frameWidth: 101, frameHeight: 181, endFrame: 4 });
        this.load.spritesheet('arrow', 'Sprites/arrowSpriteSheet_1.png', { frameWidth: 398, frameHeight: 2867, endFrame: 3 });

        this.load.json('map', 'map.json');
        this.load.json('wave', 'wave.json');
        this.load.json('colliders', 'tilemap.json');

        this.load.on('progress', (value) => {
            this.gameZop_Loaded.setCrop(0, 0, Math.FloorTo(value * 500), 131);
            App.gamezopSDK.updateLoading(Math.FloorTo(value * 100));
        });

        this.load.on('complete', () => {
            this.scene.launch('game');
        });
    }
}